import {
  WebsiteTrFooter,
  WebsiteEnFooter,
  HeaderComponent,
} from "../components";
import { type IContent } from "@kunduz/data-access-cms-api";
import { NextSeo } from "next-seo";
import Head from "next/head";
import { ComponentRenderer } from "../components/componentRenderer/componentRenderer";
import { Render } from "@measured/puck";
import { puckConfig } from "@kunduz/feature-puck-editor";

export function CmsBackedLandingPage({
  meta,
  lang,
  by,
  contentType,
}: {
  meta: IContent.IContentTypeResponse;
  lang: "tr" | "en";
  by?: "cms" | "puck";
  contentType: IContent.ContentType & IContent.ContentTypeContent;
}) {
  const headerBannerData = meta?.components?.find(
    (component) => component.component_type === "header-banner",
  );

  if (by === "puck" && contentType) {
    return <Render config={puckConfig} data={contentType?.content} />;
  }

  return (
    <>
      <Head>
        <link rel="preconnect" href="https://media.kunduz.com" />
      </Head>
      <NextSeo
        title={meta?.seo_title}
        description={meta?.seo_desc}
        canonical={meta?.canonical_url}
        noindex={meta?.no_index}
        openGraph={{
          images: [{ url: meta?.seo_icon as string }],
        }}
      />

      <HeaderComponent
        language={lang}
        headerContactShow={!!meta?.header_items?.top_item}
        headerContactData={meta?.header_items?.top_item}
        headerBannerShow={!!headerBannerData}
        headerBannerData={headerBannerData?.data?.[0]}
        headerShow={!!meta.header_items}
        headerItems={meta.header_items}
      />

      <ComponentRenderer components={meta.components} lang={lang} />

      {lang == "tr" && <WebsiteTrFooter />}
      {lang == "en" && <WebsiteEnFooter />}
    </>
  );
}
